<table class="pickup-table">
    <thead>
        <tr>
            <th>Pickup Number</th>
            <th>Status</th>
            <th>Requested Date</th>
            <th>Confirmed Date</th>
            <th>Driver</th>
            <th>Trucking Company</th>
            <th>Security Gate Fee</th>
            <th>Prepaid</th>
            <th>Remaining Balance</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let pickup of pickups">
            <tr>
                <td>{{ pickup.PickupNumber }}</td>
                <td>{{ PickupStatus[pickup.StatusId] }}</td>
                <td>{{ pickup.DateRequested | date: 'medium' }}</td>
                <td>{{ pickup.DateConfirmed ? (pickup.DateConfirmed | date: 'medium') : '—' }}</td>

                <td>{{ pickup.Driver?.FirstName }} {{ pickup.Driver?.LastName }}</td>
                <td>{{ pickup.Carrier?.Name }}</td>
                <td>${{ pickup.SecurityGateFee | number: '1.2-2' }}</td>
                <td>${{ totalPrePayment(pickup) | number: '1.2-2' }}</td>
                <td>${{ totalRemainingBalance(pickup) | number: '1.2-2' }}</td>
            </tr>

            <tr *ngFor="let order of pickup.Orders" class="order-row">
                <td colspan="2">↳ Order #{{ order.OrderNumber }}</td>
                <td>Office: {{ order.Warehouse?.Office?.Title }}</td>
                <td>Warehouse: {{ order.Warehouse?.WarehouseId }}</td>
                <td>Customer: {{ order.Customer?.Name }}</td>
                <td>Pallets: {{ order.TotalPallet }}</td>
                <td colspan="3">Weight: {{ order.TotalWeight }} lbs</td>
            </tr>
        </ng-container>
    </tbody>
</table>

<br />

<button class="btn btn-primary" (click)="goToPickupsPage()">Go to Pickups Page</button>
<button class="btn btn-danger" (click)="close()">Cancel</button>
